import { cardVisitConstants } from '../constants';
import { makeGETRequest, makePOSTRequest } from '../utils/Axios';

export const card_visitActions = {
  getCardVisits,
  createCardVisit
}

export function getCardVisits({workspace_id, ...props}) {
  return function (dispatch) {
    try{
      props?.onBefore?.();
      makeGETRequest(`/api/v1/content_group_visits/${workspace_id}`)
      .then(response => {
        if(response.data.status === "ok"){
          props?.onSuccess?.(response);
        }else {
          props?.onError?.(response);
        }
      })
    }catch(e){
      dispatch( {
             type: cardVisitConstants.CARD_VISIT_FAILURE,
             payload: console.log(e),
      })

      props?.onFailure?.();
    }
  }
}

export function createCardVisit({params, workspace_id, ...props}) {
  return function (dispatch) {
    try{
      props?.onBefore?.();
      makePOSTRequest(`/api/v1/content_group_visits/${workspace_id}`, { card_visit: params })
      .then(response => {
        if(response.data.status === "ok"){
          props?.onSuccess?.(response);
        }else {
          props?.onError?.(response);
        }
      })
    }catch(e){
      dispatch( {
             type: cardVisitConstants.CARD_VISIT_FAILURE,
             payload: console.log(e),
      })

      props?.onFailure?.();
    }
  }
}
